import React, {useEffect} from "react"
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import Echo from "laravel-echo";
import {toAbsoluteApiUrl} from "../_metronic/_helpers";
import {toast} from "react-toastify";
import {AEToaster} from "./components/toastify/AEAlert";
import {AELink} from "./components/AELink";
import {actionTypes} from "../app/modules/Auth/_redux/Notifications/slice";
import {fetchNotifications} from "../app/modules/Auth/_redux/Notifications/actions";
import {fetchNotificationsStatistics} from "../app/pages/Dashboard/_redux/actions";

window.Pusher = require('pusher-js');

const appKey = '8bca4bde5b203ab7d844' //todo env
const getPusherConfig = (access_token)=>({
  cluster: 'eu',
  authEndpoint: toAbsoluteApiUrl("/broadcasting/auth"),
  auth: {
    headers: {
      Authorization: `Bearer ${access_token}`,
      Accept: 'application/json',
    },
  },

})

const _pusher = new window.Pusher(
  appKey,
  {
    cluster: 'eu',
    authEndpoint: toAbsoluteApiUrl("/broadcasting/auth"),
    auth: {
      headers: {
        // Authorization: `Bearer ${access_token}`,
        Accept: 'application/json',
      },
    },

  }
  )


export const AENotification = ({event, })=>{
  const {user, access_token} = useSelector( ({auth}) => auth, shallowEqual );
  const dispatch = useDispatch();
  const refreshNotifications = () => {
    dispatch(fetchNotifications())
    dispatch(fetchNotificationsStatistics())
  }

  useEffect(()=>{
    // console.log({_pusher})
    if (access_token) {
      // _pusher.config.auth.headers.Authorization = `Bearer ${access_token}`
      // const _pusher = new window.Pusher(appKey, getPusherConfig(access_token));

      // const channel = _pusher.subscribe(`private-user.${user.id}`);
      const channel = _pusher.subscribe(`App.User.${user.id}`);
      channel.bind(event, function(data) {
        const {url} = data;
        refreshNotifications()
        toast(
          <AELink to={url}>
            <AEToaster
              message={{id: event}}
            />
          </AELink>)
        //todo refresh notification
      });
    }

  }, [user, access_token])

  return <></>
}